"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20GameScene = void 0;
const Game_1 = require("./Game");
const IGO50Terminal_1 = require("./IGO50Terminal");
const KHRandom_1 = require("./KH/KHRandom");
const TSBlock_1 = require("./TSBlock");
const TSColors_1 = require("./TSColors");
const Z20Entity_1 = require("./Z20Entity");
const Z20Grid_1 = require("./Z20Grid");
const Z20Inventory_1 = require("./Z20Inventory");
const Z20InventoryDisplay_1 = require("./Z20InventoryDisplay");
const IGO50PausableScene_1 = require("./IGO50PausableScene");
const Z20RuleDisplay_1 = require("./Z20RuleDisplay");
const Z20SceneNames_1 = require("./Z20SceneNames");
const Z20Setup_1 = require("./Z20Setup");
const Z20TerminalSetup_1 = require("./Z20TerminalSetup");
const soundPriority = ["move_death", "move_pickup", "move_bad", "move"];
class Z20GameScene extends IGO50PausableScene_1.default {
    constructor() {
        super(Z20SceneNames_1.default.Game);
        this._timerPaused = true;
        this.off = { x: -8, y: -12 };
        this.waitingForInput = false;
        this.won = false;
        this.requestedSounds = [];
    }
    blocksAt(x, y) {
        return this.grid.at(x, y);
    }
    getControlledBlock() {
        return this.controlledBlock;
    }
    init(data) {
        if (!data || !data.config)
            console.log("Game didn't get config");
        this.config = data.config || Z20TerminalSetup_1.Z20TerminalSetup.StandardSetup;
        if (!data || !data.setup) {
            const seed = Math.floor(Math.random() * 1000000);
            console.log('Seed', seed);
            const random = new KHRandom_1.KHRandomSeedable(seed);
            this._setup = new Z20Setup_1.Z20Setup(random, 6, this.config);
        }
        else {
            this._setup = data.setup;
        }
        if (this.config.saveProgress) {
            Game_1.game.inProgress.set(true);
            Game_1.game.attempts.set(Game_1.game.attempts.get() + 1);
        }
        this._totalTime = 0;
    }
    create() {
        this.audioScene = Game_1.gameManager.addOrGetAudioScene(this);
        this.controller = Game_1.gameManager.getController();
        this.waitingForInput = false;
        const dimensions = { x: 7, y: 7 };
        const gridSize = 16 * (dimensions.x - 1);
        this.add.existing(new Z20RuleDisplay_1.Z20RuleDisplay(this, 60, Game_1.game.height / 2, this._setup).setDepth(4));
        this._inventoryDisplay = new Z20InventoryDisplay_1.Z20InventoryDisplay(this, Game_1.game.width - 60, Game_1.game.height / 2, this._setup).setDepth(4);
        this.add.existing(this._inventoryDisplay);
        this._tileGrid = [];
        const width = Math.ceil(Game_1.game.width / 16) + 1;
        const height = Math.ceil(Game_1.game.height / 16) + 1;
        for (let x = 0; x < width; x++) {
            const arr = [];
            for (let y = 0; y < height; y++) {
                const sprite = this.add.sprite(x * 16 + this.off.x, y * 16 + this.off.y, `grass${this._setup.random.nextInt(0, Game_1.game.grassCount)}`).setOrigin(0, 0).setDepth(-1);
                const tsprite = this.add.sprite(x * 16 + this.off.x, y * 16 + this.off.y, `tree`).setOrigin(0, 0).setDepth(-1);
                arr.push([sprite, tsprite]);
            }
            this._tileGrid.push(arr);
        }
        this.grid = new Z20Grid_1.Z20Grid((Game_1.game.width - gridSize) / 2, (Game_1.game.height - gridSize) / 2, dimensions, 16);
        this._movementAllowed = false;
        this.timeLeft = Z20GameScene.TIME_LIMIT;
        const timerBG = this.add.rectangle(Game_1.game.width / 2, 12, 32, 14, 0x0).setDepth(1);
        this._timerText = this.add.bitmapText(Game_1.game.width / 2, 13, 'legacys', '19.00').setOrigin(.5, .5).setDropShadow(0, 1, 0x0, 1).setDepth(2);
        this._winBG = this.add.rectangle(Game_1.game.width / 2 - 1, Game_1.game.height / 2, width, height, 0x003d10).setDepth(4);
        this._winText = this.add.bitmapText(Game_1.game.width / 2, Game_1.game.height / 2, 'igo50', 'TROPHY GET!').setOrigin(.5, .5).setDepth(5);
        this._winBG.setSize(this._winText.width + 1, this._winText.height + 1);
        this.showRoundWinText(false);
        this._loseBG = this.add.rectangle(Game_1.game.width / 2 - 2, Game_1.game.height / 2, width, height, 0x4430ba).setDepth(9);
        this._loseText = this.add.bitmapText(Game_1.game.width / 2, Game_1.game.height / 2, 'igo50', 'YOU LOST THE GAME.').setOrigin(.5, .5).setDepth(10);
        this._loseBG.setSize(this._loseText.width - 2, this._loseText.height + 1);
        this.showRoundLoseText(false);
        this._currentLevel = 0;
        this.loadNextLevel();
    }
    showRoundWinText(show) {
        this._winBG.visible = show;
        this._winText.visible = show;
    }
    showRoundLoseText(show) {
        this._loseBG.visible = show;
        this._loseText.visible = show;
    }
    setTime(time) {
        if (time < 0)
            time = 0;
        this._timerText.setText(time.toFixed(2).padStart(5, '0'));
    }
    giveItem(item) {
        const added = this._inventory.addTool(item);
        if (added) {
            this._inventoryDisplay.addItem(item);
            this.requestedSounds.push("move_pickup");
        }
        return added;
    }
    hasItem(item) {
        return this._inventory.has(item);
    }
    maybePlaySound() {
        for (let sound of soundPriority) {
            if (this.requestedSounds.includes(sound)) {
                this.audioScene.playSfx(sound);
                break;
            }
        }
        this.requestedSounds = [];
    }
    updateTerminalCode() {
        let code = '';
        if (!this.config.saveProgress) {
        }
        else if (this._currentLevel === 0) {
            code = 'ONES-RUNS';
        }
        else if (this._currentLevel === 1) {
            code = 'TWOS-CREW';
        }
        else if (this._currentLevel === 2) {
            code = '3HAS-TOBE';
        }
        else if (this._currentLevel === 3) {
            code = 'FOUR-EVER';
        }
        else {
            code = 'FIVE-HIVE';
        }
        IGO50Terminal_1.default.CurrentCode = code;
    }
    loadNextLevel() {
        this.updateTerminalCode();
        this.showRoundWinText(false);
        const config = this._setup.levels[this._currentLevel];
        const pos = this.computeGridPos(config);
        this.grid = new Z20Grid_1.Z20Grid(pos.start.x * 16 + 8 + this.off.x, pos.start.y * 16 + 8 + this.off.y, config.size, 16);
        const radius = Math.sqrt(config.size.x / 2 * config.size.x / 2 + config.size.y / 2 * config.size.y / 2);
        for (let x = 0; x < this._tileGrid.length; x++) {
            for (let y = 0; y < this._tileGrid[x].length; y++) {
                const tile = this._tileGrid[x][y];
                if (x >= pos.start.x && (x < pos.start.x + config.size.x) && y >= pos.start.y && (y < pos.start.y + config.size.y)) {
                    tile[1].visible = false;
                    tile[0].setFrame(0);
                    tile[1].setFrame(0);
                }
                else {
                    tile[1].visible = true;
                    const dist = Phaser.Math.Distance.Between(pos.mid.x - 1, pos.mid.y - 1, x, y);
                    const frame = Math.max(0, Math.min(3, Math.floor(dist - radius)));
                    tile[0].setFrame(frame);
                    tile[1].setFrame(frame);
                }
            }
        }
        const levels = Game_1.gameManager.getGames();
        const currentLevel = 1;
        this._inventory = new Z20Inventory_1.Z20Inventory();
        this._inventoryDisplay.clearItems();
        this.animateGridIn(config);
        if (currentLevel >= levels.length) {
            this.tweens.add({
                targets: this._board,
                x: 64,
                duration: 750,
                ease: Phaser.Math.Easing.Sine.In,
                onComplete: () => {
                }
            });
            return;
        }
        const level = levels[currentLevel];
        this.startLevel(level(), config);
        // this._dealSound?.play()
    }
    startLevel(level, config) {
        this.placedBlocks = 0;
        this.controlledBlockArr = [];
        this.controlledBlock = null;
        this._game = level;
        this._game.gameInterface = this;
        this._game.onStart(this, this._setup, config);
        this.timeLeft = Z20GameScene.TIME_LIMIT;
        this.setTime(this.timeLeft);
        this.time.addEvent({
            delay: 50 * this.placedBlocks + 750,
            callback: () => {
                this._movementAllowed = true;
                this._timerPaused = false;
            }
        });
    }
    scheduleKill(block) {
        block.kill();
    }
    ;
    goToNextControlledBlock(killCurrent) {
        if (killCurrent) {
            this.controlledBlock.kill();
        }
        if (this.controlledBlockArr.length == 0) {
            return null;
        }
        else {
            const newBlock = this.controlledBlockArr.shift();
            this.setControlledBlock(newBlock);
            return newBlock;
        }
    }
    addBlock(block, x, y, controlled) {
        this.addToGrid(block, x, y);
        if (controlled) {
            if (this.controlledBlock != null) {
                this.controlledBlockArr.unshift(this.controlledBlock);
            }
            this.setControlledBlock(block);
        }
    }
    addBlockNoAnim(block, x, y) {
        this.addToGrid(block, x, y, false);
    }
    swap(block, x, y) {
        this.grid.swapWith(block, x, y);
    }
    darknessAnimation(cb) {
        let i = 0;
        this.time.addEvent({
            delay: 200 / 3,
            callback: () => {
                i++;
                cb(i);
            },
            repeat: 3
        });
    }
    computeGridPos(config) {
        let gridMX = 14;
        const gridMY = 8;
        const oGridSX = gridMX - Math.floor(config.size.x / 2) - 1;
        const gridSX = Math.max(9, oGridSX);
        const gridSY = gridMY - Math.floor(config.size.y / 2) - 1;
        gridMX += gridSX - oGridSX;
        return { start: { x: gridSX, y: gridSY }, mid: { x: gridMX, y: gridMY } };
    }
    animateGridIn(config) {
        const pos = this.computeGridPos(config);
        const radius = Math.sqrt(config.size.x / 2 * config.size.x / 2 + config.size.y / 2 * config.size.y / 2);
        for (let x = 0; x < this._tileGrid.length; x++) {
            for (let y = 0; y < this._tileGrid[x].length; y++) {
                const tile = this._tileGrid[x][y];
                tile[0].setFrame(3);
                tile[1].setFrame(3);
            }
        }
        this.darknessAnimation((thisFrame) => {
            for (let x = 0; x < this._tileGrid.length; x++) {
                for (let y = 0; y < this._tileGrid[x].length; y++) {
                    const tile = this._tileGrid[x][y];
                    const dist = Phaser.Math.Distance.Between(pos.mid.x - 1, pos.mid.y - 1, x, y);
                    const lighting = Math.min(3, Math.floor(dist - radius));
                    const frame = Math.max(0, Math.min(3, lighting + 4 - thisFrame));
                    tile[0].setFrame(frame);
                    tile[1].setFrame(frame);
                }
            }
        });
    }
    animateGridOut() {
        this.darknessAnimation(() => {
            for (let x = 0; x < this._tileGrid.length; x++) {
                for (let y = 0; y < this._tileGrid[x].length; y++) {
                    const tiles = this._tileGrid[x][y];
                    const frame = Math.min(3, Number(tiles[0].frame.name) + 1);
                    tiles[0].setFrame(frame);
                    tiles[1].setFrame(frame);
                }
            }
        });
    }
    cleanupTrees() {
        const trees = this.grid.allPieces().filter(x => x._type === TSColors_1.TSBlockType.Tree);
        this.darknessAnimation((frame) => {
            if (frame >= 3) {
                for (let tree of trees) {
                    tree.destroy();
                }
            }
            else {
                for (let tree of trees) {
                    tree.setFrame(frame);
                }
            }
        });
    }
    lose() {
        this.requestedSounds.push('move_death');
        this.realLose();
    }
    realLose() {
        this._totalTime += (Z20GameScene.TIME_LIMIT - this.timeLeft);
        this.updateProgressForLose();
        this._timerPaused = true;
        const killTime = 300;
        this._movementAllowed = false;
        this.won = false;
        this.showRoundLoseText(true);
        this.time.addEvent({
            delay: killTime,
            callback: () => {
                const delay = 500;
                this.time.addEvent({
                    delay,
                    callback: () => {
                        this.modeEnded(false);
                    }
                });
            }
        });
    }
    win() {
        this._timerPaused = true;
        this._movementAllowed = false;
        const betweenDelay = 30;
        this.controlledBlock.showTrophy(true);
        const all = this.grid.allPieces().filter(x => x._type !== TSColors_1.TSBlockType.Tree && x != this.controlledBlock);
        new KHRandom_1.KHRandomGeneral().shuffleArray(all);
        let highestPos = 0;
        const rand = new KHRandom_1.KHRandomGeneral();
        const dir = rand.nextInt(0, 4);
        const off = { x: 0, y: 0 };
        if (dir === 2)
            off.x = 1;
        else if (dir === 3)
            off.x = -1;
        else if (dir === 0)
            off.y = 1;
        else
            off.y = -1;
        for (let i = 0; i < all.length; i++) {
            const pos = all[i].pos.x + all[i].pos.y;
            if (all[i]._type instanceof Z20Entity_1.default && all[i].entity.wins) {
                all[i].silentKill();
            }
            else {
                all[i].runAway(i * 16, off);
            }
            // all[i].celebrate(pos * betweenDelay, true)
            highestPos = Math.max(pos, highestPos);
        }
        this.controlledBlock.runAway(500, off);
        this.cleanupTrees();
        this.animateGridOut();
        this._inventoryDisplay.animateClearItems();
        this.won = true;
        this.showRoundWinText(true);
        this.audioScene.playSfx('win');
        this.time.addEvent({
            delay: highestPos * betweenDelay + 1000 + 500,
            callback: () => {
                this.modeEnded(true);
            }
        });
    }
    modeEnded(win) {
        this.placedBlocks = 0;
        this.waitingForInput = true;
    }
    updateTotalTime() {
        Game_1.game.totalTime.set(Game_1.game.totalTime.get() + this._totalTime);
    }
    updateProgressForLose() {
        // Time is updated regardless of setting.
        this.updateTotalTime();
        if (!this.config.saveProgress)
            return;
        Game_1.game.currentStreak.set(0);
        Game_1.game.inProgress.set(false);
        Game_1.game.totalTime.set(Game_1.game.totalTime.get() + this._totalTime);
    }
    updateProgressForWin() {
        // Time is updated regardless of setting.
        this.updateTotalTime();
        if (!this.config.saveProgress)
            return;
        Game_1.game.inProgress.set(false);
        Game_1.game.wins.set(Game_1.game.wins.get() + 1);
        Game_1.game.currentStreak.set(Game_1.game.currentStreak.get() + 1);
        if (Game_1.game.currentStreak.get() > Game_1.game.bestStreak.get()) {
            Game_1.game.bestStreak.set(Game_1.game.currentStreak.get());
        }
        Game_1.game.totalTime.set(Game_1.game.totalTime.get() + this._totalTime);
        Game_1.game.highScores.addScore("", { time: this._totalTime });
    }
    triggerNextLevel() {
        this.waitingForInput = false;
        this._currentLevel++;
        this._totalTime += (Z20GameScene.TIME_LIMIT - this.timeLeft);
        console.log("Time so far", this._totalTime);
        if (this.won && this._setup.levels.length <= this._currentLevel) {
            this.updateProgressForWin();
            this.config.onWin(this, this.config, this._setup, this._totalTime);
        }
        else {
            this.loadNextLevel();
        }
    }
    addToGrid(block, x, y, anim = true) {
        this.add.existing(block);
        block.addToGrid(this.grid, x, y);
        if (block._type === TSColors_1.TSBlockType.Tree) {
            block.setFrame(3);
            this.darknessAnimation((i) => {
                block.setFrame(Math.max(0, 2 - i));
            });
        }
        else if (anim) {
            block.animateIn(this.placedBlocks * 50);
            this.placedBlocks++;
        }
        return block;
    }
    setControlledBlock(block) {
        this.controlledBlock = block;
        block.setDepth(1);
    }
    update(time, delta) {
        if (this.waitingForInput && this.controller.getInput(Game_1.Controls.Confirm).isJustDown()) {
            this.audioScene.playSfx('move');
            this.waitingForInput = false;
            if (this.won) {
                this.triggerNextLevel();
            }
            else {
                this.config.onLose(this, this.config);
            }
            return;
        }
        if (this._movementAllowed && this.controlledBlock) {
            if (this.controller.getInput(Game_1.Controls.Up).isJustDown()) {
                this.moveOffset(TSBlock_1.TSDir.Up);
            }
            else if (this.controller.getInput(Game_1.Controls.Down).isJustDown()) {
                this.moveOffset(TSBlock_1.TSDir.Down);
            }
            else if (this.controller.getInput(Game_1.Controls.Right).isJustDown()) {
                this.moveOffset(TSBlock_1.TSDir.Right);
            }
            else if (this.controller.getInput(Game_1.Controls.Left).isJustDown()) {
                this.moveOffset(TSBlock_1.TSDir.Left);
            }
        }
        if (!this._timerPaused) {
            this.timeLeft -= delta / 1000;
            this.setTime(this.timeLeft);
        }
        if (this.timeLeft <= 3 && this.timeLeft > 0 && !this._timerPaused) {
            if (Math.floor(this.timeLeft) < Math.floor(this.timeLeft + delta / 1000)) {
                this.audioScene.playSfx('tick');
            }
        }
        if (!this._timerPaused && this.timeLeft <= 0) {
            this.timeOutLose();
        }
        super.update(time, delta);
    }
    timeOutLose() {
        this.audioScene.playSfx('time_up');
        this.realLose();
    }
    moveOffset(dir) {
        this._game.onWillMove(this.controlledBlock);
        const block = this.controlledBlock;
        const offset = TSBlock_1.TSBlockMoving.OffsetForDir(dir);
        if (dir === TSBlock_1.TSDir.Left) {
            this.controlledBlock.setFlipped(false);
        }
        else if (dir === TSBlock_1.TSDir.Right) {
            this.controlledBlock.setFlipped(true);
        }
        const start = [this.controlledBlock.pos.x, this.controlledBlock.pos.y];
        const desired = [this.controlledBlock.pos.x + offset[0], this.controlledBlock.pos.y + offset[1]];
        const moved = this.grid.tryMoveTo(this.controlledBlock, dir);
        this._game.onDidMove(this.controlledBlock, start, desired, moved);
        if (block.isDead()) {
            // KHInputProvider.lastInputSource?.tryVibrate(100, 0, 0.3)
            this.requestedSounds.push('move_death');
        }
        else if (moved) {
            // KHInputProvider.lastInputSource?.tryVibrate(20, 0.1, 0)
            this.requestedSounds.push('move');
        }
        else {
            // KHInputProvider.lastInputSource?.tryVibrate(20, 0.3, 0)
            this.requestedSounds.push('move_bad');
        }
        this.maybePlaySound();
    }
}
exports.Z20GameScene = Z20GameScene;
Z20GameScene.TIME_LIMIT = 20;
